/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Progress, Statistic, Row, Col, Card, Button, Timeline, Divider } from "antd";
import styled from 'styled-components';
import { useResizeContext } from "datastake-daf/dist/context";
import SupplyChainMap from './dashboard/widget/supply-chain-map';
import { actions } from "../../../../store/reducers/dashboard";
import { useTranslation } from "react-i18next";
import { getProgressColor } from "../../../../helpers/Progress";
import { PROJECTS } from "../../../../helpers/CanAccess";
import Loading from "../../../../components/Loading";
import { GetIcon, Header } from 'datastake-daf/dist/components';
import TradeRelationShip from "../../../../components/dashboards/components/TradeRelationShip";
import DashboardStyle from "../../../../components/dashboards/pme/IA/default/styles";
import Map from "../../pme/screens/dashboard/widgets/map/index";
import { PmeDashboardStyle } from "./dashboard/style";
import { DashboardService } from "../../../../services";
import Project from "./dashboard/project";
import { usePermissions } from "../../../../permissions/usePermissions";
import { useModule } from "../../../../helpers/user";
import ReactHtmlParser from 'react-html-parser';

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: start;
	.ant-page-header {
    padding: 8px 8px 8px var(--size);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .ant-page-header-heading {
			justify-content: flex-start;
    }
    .ant-page-header-heading-extra {
			display: flex;
			margin-left: var(--size);
		}
    .ant-btn {
      display: flex;
      span[role="img"] {
        font-size: 18px;
      }
    }
	}
	.content {
		padding: var(--size);
		h5 {
			font-weight: 400;
		}
	}
	.ant-table-wrapper {
		margin: var(--size) 0;
	}
	.ant-row {
		margin-top: var(--size);
	}
	.ant-card-body {
		background-color: #fafafa;
	}
	.ant-col.ant-col-6 {
		margin-bottom: var(--size);
	}
	.btn-action {
    float: right;
    width: 170px;
  }
  .statistic-with-icon {
    display: flex;
    justify-content: space-between;
    .anticon {
      font-size: 40px;
    }
  }
  .ant-card-cover {
    padding: 1em;
    text-align: center;
  }
  .btn2-action{
    width: 80%;
  }
  .ant-btn {
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),
      0 2px 2px 0 rgba(0,0,0,.14),
      0 1px 5px 0 rgba(0,0,0,.12);
  }
  .ant-card {
    margin-bottom: var(--size)
  }
   .ant-divider-horizontal.ant-divider-with-text-left::after {
    top: 0%;
  }

  .ant-divider {
    font-size: 18px;
    font-weight: 600;
		font-family: SF UI Display;
    line-height: 22px;
    color: #595959;
    position: relative;

    &::before {
      display: none;
    }

    span {
      padding-left: 0;
    }

    &::after {
      border-top: 1px solid #D1D1D1;
    }
  }
  .ant-timeline {
    height: 280px;
    overflow-y: auto;
    padding: 10px 0;
  }
  .ant-timeline-item-last > .ant-timeline-item-content {
    min-height: 1px;
  }
`;

const demo = process.env.REACT_APP_ENV === 'demo';
const language = '';

function Dashboard({
  authentication: { user, selectedProject },
  dashboard: { cadd: { retrieved, data, loading } },
  project: { data: { projects } },
  CaddDashboardGet,
}) {
  const goTo = useNavigate();
  const { isCollapsed: sidebarCollapsed } = useResizeContext();
  const [projectData, setProjectData] = useState(null);
  const [emptyStateIsShown, setEmptyStateIsShown] = useState(true);
  const { canCreate } = usePermissions({ permission: 'projects', defaultValue: {} });
  const { mod } = useModule();

  useEffect(() => {
    if (projects && projects.length && selectedProject) {
      const pData = projects.find(p => p.id === selectedProject);
      if (pData) {
        setProjectData(pData);
      } else if (selectedProject === 'myOwnData') {
        setProjectData({});
      }
    } else {
      setProjectData({});
    }
  }, [projects, selectedProject]);

  const cardData = [
    {
      name: 'Projects',
      value: data.projects,
      icon: 'FundProjectionScreenOutlined',
      link: `/app/${mod}/projects?create`,
      viewLink: `/app/${mod}/projects`,
      linkText: 'Create',
      linkDisabled: !canCreate || demo,
      own: true,
      project: false,
    },
    {
      name: 'Due Diligence Documents',
      value: data.reports || 0,
      icon: 'folder-shield-2-line',
      viewLink: `/app/${mod}/due-diligence`,
      linkDisabled: false,
      own: false,
      project: true,
    },
    {
      name: 'Mine Sites',
      value: data.sites,
      icon: 'RadarChartOutlined',
      ...(selectedProject === PROJECTS.myData ? {
        linkText: 'Add',
        link: `/app/${mod}/scl?create`,
      } : {}
      ),
      viewLink: `/app/${mod}/scl`,
      linkDisabled: false,
      own: true,
      project: true,
    },
    {
      name: 'Events',
      value: data.events,
      icon: 'SendOutlined',
      ...(selectedProject === PROJECTS.myData ? {
        linkText: 'Add',
        link: `/app/${mod}/events?create`,
      } : {}
      ),
      viewLink: `/app/${mod}/events`,
      linkDisabled: false,
      own: true,
      project: true,
    },
    {
      name: 'Supply Chain Actors',
      value: data.suppliers,
      icon: 'UserOutlined',
      ...(selectedProject === PROJECTS.myData ? {
        linkText: 'Add',
        link: `/app/${mod}/scp?create`
      } : {}
      ),
      viewLink: `/app/${mod}/scp`,
      linkDisabled: false,
      own: true,
      project: true,
    },
    {
      name: 'Other Stakeholders',
      value: data.stakeholders,
      icon: 'UsergroupAddOutlined',
      ...(selectedProject === PROJECTS.myData ? {
        linkText: 'Add',
        link: `/app/${mod}/stakeholders?create`,
      } : {}
      ),
      viewLink: `/app/${mod}/stakeholders`,
      linkDisabled: false,
      own: true,
      project: true,
    },
    {
      name: 'Shipments',
      value: data.shipments || 0,
      icon: 'CodeSandboxOutlined',
      linkText: 'View',
      linkDisabled: true,
      own: true,
      project: true,
    },
    {
      name: 'Information Sources',
      value: data.sources || 0,
      icon: 'folder-shield-2-line',
      viewLink: `/app/${mod}/is`,
      linkDisabled: false,
      own: false,
      project: true,
    }
  ];

  useEffect(() => {
    if (projectData && selectedProject === PROJECTS.myData) {
      if (projectData) {
        const isScpProject = (projectData && projectData.typeOfProject && projectData.typeOfProject === 'supplyChain') ? true : false;
        CaddDashboardGet({ isScpProject, selectedProject });
      } else {
        CaddDashboardGet({ isScpProject: false, selectedProject });
      }
    }
  }, [projectData, user.language]);

  const supplyChainCallback = (itemToFocus, activeSources) => {
    return DashboardService.getCaddSupplyChainMap(itemToFocus, activeSources);
  }

  const { t } = useTranslation();
  const progressColor = getProgressColor(data.kycProgress);

  if (selectedProject !== PROJECTS.myData) {
    return <Project sidebarCollapsed={sidebarCollapsed} />;
  }

  if (loading || !retrieved) {
    return <Loading />;
  }

  return (
    <Styles className="semibold form-input-output">
      <Header
        title={selectedProject === PROJECTS.myData ? t("CADD Dashboard") : (projectData ? projectData.name : '')}
      />
      <div className="content  app-content" role="main">
        <DashboardStyle style={{ width: '100%' }} className="bg-white" isMapToggled={true}>
          <div
            role="content"
            style={{
              padding: '15px',
              paddingBottom: '0',
              marginBottom: '20px',
            }}>
            <Divider orientation="left">{t('Key Data')}</Divider>
            <Row gutter={12}>
              {cardData.filter(c => selectedProject === PROJECTS.myData ? c.own : c.project).map(({ name, value, icon: Icon, link, linkText, linkDisabled, viewLink }) =>
                <Col span={8} key={name}>
                  <Card>
                    <div className="statistic-with-icon">
                      <Statistic
                        title={t(name)}
                        value={value}
                      />
                      <GetIcon icon="Icon" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: !viewLink ? 'flex-end' : 'space-between', marginTop: 'var(--size)' }}>
                      {link ? (
                        <Button disabled={linkDisabled} type="primary btn-action" onClick={() => goTo(link)} >{t(linkText)}</Button>
                      ) : (
                        <Button disabled={linkDisabled} type="primary btn-action" >{t(linkText)}</Button>
                      )}
                      {viewLink ? (
                        <Button disabled={linkDisabled} type="primary btn-action" onClick={() => goTo(viewLink)}>{t("View")}</Button>
                      ) : null}
                    </div>
                  </Card>
                </Col>
              )}
            </Row>
            {selectedProject === PROJECTS.myData ? <Row>
              <Col span={8} style={{ paddingRight: '8px' }}>
                <Card
                  title={t("KYC Status")}
                  cover={
                    retrieved && <Progress type="circle" showInfo={true} percent={data.kycProgress} strokeColor={progressColor} />
                  }
                  actions={[
                    <Button type="primary" className="btn2-action" onClick={() => goTo(`/app/${mod}/edit/kyc/user`)} >{data.kycProgress === 0 ? t('Create') : t('Edit')}</Button>,
                    <Button type="primary" className="btn2-action" onClick={() => goTo(`/app/${mod}/analysis/kyc`)} >{t("Consult")}</Button>,
                    <Button disabled type="primary" className="btn2-action" >{t("Share")}</Button>
                  ]

                  }
                >
                  {data.kycProgress === 0 ? (
                    <div className="red">{t("KYC information has not provided")}</div>
                  ) : data.kycProgress < 100 ? (
                    <div className="red">{t("KYC information has been submitted but is incomplete")}</div>
                  ) : null}

                </Card>
              </Col>
              <Col span={8} style={{ paddingLeft: '12px' }}>
                <h1 style={{ marginBottom: '32px' }}>{t("Timeline")}</h1>
                <Timeline>
                  {data && data.timeline && data.timeline.map((t, k) => (
                    <Timeline.Item key={k}>
                      {ReactHtmlParser(t)}
                    </Timeline.Item>
                  ))}
                </Timeline>
              </Col>
            </Row> : null}
            {selectedProject === PROJECTS.myData ? (
              <>
                <Divider orientation="left">{t('Trade Relationships')}</Divider>
                <div className="row between mb-20" style={{
                  height: '500px',
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                  borderRadius: '3px',
                  width: '100%',
                  margin: '0 auto 20px auto'
                }}>
                  <TradeRelationShip
                    module="cadd"
                    showSelects={selectedProject !== PROJECTS.myData}
                    showTradeType={false}
                    trade={data && data.trade ? (data.trade || []) : []}
                    loadGraph={true}
                    emptyStateIsShown={emptyStateIsShown}
                    language={language}
                    setEmptyStateIsShown={setEmptyStateIsShown} />
                </div>
              </>
            ) : (
              <SupplyChainMap
                {...data.scm}
                trade={data.trade}
                datastakeId={user.company.userId}
                callback={supplyChainCallback}
              />
            )}
          </div>
        </DashboardStyle>
        <PmeDashboardStyle style={{ width: '100%' }} className="bg-white" >
          <Divider orientation="left">{t('Monitoring Scope')}</Divider>
          <section>
            <Map
              t={t}
              data={data.map}
              user={user}
              projectData={projectData}
              module="cadd"
            />
          </section>
        </PmeDashboardStyle>
      </div>
    </Styles>
  );
}

export default connect(({ authentication, dashboard, project }) => ({ authentication, dashboard, project }), actions)(Dashboard);
